window.AH = window.AngularHelper = {

    loadController: (controller) => {
        if (controller){
            import(`./controllers/${controller}`).then(( Module )=>{
                require('angular');
                // chunk();
                new Module.Controller();
            });
        } else {
            console.warn('No angular controller passed. Aborting initialization.');
            document.documentElement.className += ` angular-aborted`;
        }
    },

    controllerLoaded: () => {
        document.documentElement.className += ` angular-loaded`;
    }

};